import {
  Permission,
  SubjectPermission,
  QueryPermission,
  QCTaskPermission,
  ReadTaskPermission,
} from '@auth/permissionsEnum'
import { generatePathWithParams } from '@common/utils/urlUtils'
import { RouteConfig, ROUTES } from 'src/routes'

type SubjectTabItem = {
  route: RouteConfig
  permissions?: Permission[]
}

export const createSubjectTabItems = (
  studyId: string,
  subjectId: string,
  paginationDetails?: URLSearchParams,
): SubjectTabItem[] => [
  {
    route: {
      path: generatePathWithParams(ROUTES.SUBJECT_OVERVIEW.path, { studyId, subjectId }),
      label: 'Overview',
      paginationDetails: paginationDetails,
    },
    permissions: [SubjectPermission.ALL, SubjectPermission.VIEW, SubjectPermission.VIEW_FOR_OWN_SITE],
  },
  {
    route: {
      path: generatePathWithParams(ROUTES.SUBJECT_TIMEPOINTS.path, { studyId, subjectId }),
      label: 'Timepoints',
      paginationDetails: paginationDetails,
      aliasRoutes: [
        generatePathWithParams(ROUTES.SUBJECT_TIMEPOINT_SUBMISSION.path, {
          studyId,
          subjectId,
          timepointSubmissionId: ':timepointSubmissionId',
        }),
      ],
    },
    permissions: [SubjectPermission.ALL, SubjectPermission.VIEW, SubjectPermission.VIEW_FOR_OWN_SITE],
  },
  {
    route: {
      path: generatePathWithParams(ROUTES.SUBJECT_QC_TASKS.path, { studyId, subjectId }),
      label: 'QC Tasks',
      paginationDetails: paginationDetails,
    },
    permissions: [
      QCTaskPermission.ALL,
      QCTaskPermission.VIEW_ASSIGNED_TASKS,
      QCTaskPermission.VIEW_TASK_POOL,
      QCTaskPermission.VIEW_COMPLETED_TASKS,
      QCTaskPermission.MANAGE_TASKS,
    ],
  },
  {
    route: {
      path: generatePathWithParams(ROUTES.SUBJECT_READ_TASKS.path, { studyId, subjectId }),
      label: 'Read Tasks',
      paginationDetails: paginationDetails,
    },
    permissions: [
      ReadTaskPermission.ALL,
      ReadTaskPermission.VIEW_ASSIGNED_TASKS,
      ReadTaskPermission.VIEW_TASK_POOL,
      ReadTaskPermission.VIEW_COMPLETED_TASKS,
      ReadTaskPermission.MANAGE_READ_TASK,
    ],
  },
  {
    route: {
      path: generatePathWithParams(ROUTES.SUBJECT_QUERIES.path, { studyId, subjectId }),
      label: 'Queries',
      paginationDetails: paginationDetails,
    },
    permissions: [QueryPermission.ALL, QueryPermission.LIST_ALL, QueryPermission.LIST_FOR_OWN_SITE],
  },
]
